var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-image",
    _vm._b(
      {
        staticClass: "u-myimage",
        attrs: {
          src: _vm.formatSrc,
          "preview-src-list": _vm.formatPreviewSrcList,
        },
      },
      "el-image",
      _vm.$attrs,
      false
    ),
    [
      _c("template", { slot: "error" }, [
        !_vm.formatSrc ? _c("div") : _vm._e(),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }